import { useNavigate } from 'react-router';
import { BackButton, AuthHeading, Button } from 'view/components';
import {
  AuthFormsFooter,
  Agreement,
  Separator,
  GoogleLoginButton,
} from 'view/pages/auth/components';
import { AuthHeadingImageTypeEnums } from 'view/pages/auth/helpers';
import * as CS from 'view/pages/auth/commonStyled';

const OnboardingPage = () => {
  const navigate = useNavigate();

  return (
    <CS.Wrapper>
      <CS.BackButtonBox>
        <BackButton
          text="Back to Home"
          onClick={() => {
            window.location.href = 'https://injobnito.com/';
          }}
        />
      </CS.BackButtonBox>
      <CS.AuthMainBox component="section">
        <AuthHeading
          title="Welcome to Injobnito"
          subTitle="Start your journey toward skill-based job matching today"
          imageType={AuthHeadingImageTypeEnums.CIRCLE}
        />
        <CS.FormWrapper component="section">
          <CS.FormWrapperMain component="div">
            <GoogleLoginButton variant="contained" />
            <Separator />
            <Button
              variant="outlined"
              text="Continue with email"
              onClick={() => {
                return navigate('/auth/login', { replace: true });
              }}
            />
            <Agreement />
          </CS.FormWrapperMain>
          <AuthFormsFooter
            title="New to Injobnito?"
            hrefTo="/auth/registration"
            hrefText="Join Now"
          />
        </CS.FormWrapper>
      </CS.AuthMainBox>
    </CS.Wrapper>
  );
};

export default OnboardingPage;
